import { RightSideButtons } from './RightSideButtons';
import WFeatureTogglesMA from './WFeatureTogglesMA';
import { WInfoButtonsMa } from './WInfoButtonsMA';
import WUserInfoMA from './WUserInfoMA';

export function TMetaA() {
  return (
    <>
      <WUserInfoMA />
      <WInfoButtonsMa />
      <WFeatureTogglesMA />
      <RightSideButtons />
    </>
  );
}
